import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "../lib/api";
import { SEO } from "../components/SEO";
import { Reveal } from "../components/Reveal";

export default function JournalArticle() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/journal/${id}`).then((r) => setArticle(r.data)).catch(() => setError(true));
  }, [id]);

  return (
    <main data-testid="journal-article-page" className="mx-auto max-w-3xl px-5 pb-24 pt-32 sm:px-8">
      {article && (
        <SEO title={article.title} path={`/journal/${article.content_id || id}`} type="article"
             description={article.excerpt || article.title} image={article.image_url} />
      )}
      <Link to="/journal" data-testid="journal-back"
            className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-[0.25em] text-zinc-500 transition-colors hover:text-amber-400">
        <ArrowLeft className="h-3.5 w-3.5" /> Journal
      </Link>

      {error && <p className="mt-16 text-center text-zinc-500" data-testid="journal-not-found">Article introuvable.</p>}
      {!article && !error && <p className="mt-16 text-sm text-zinc-500">Chargement…</p>}

      {article && (
        <Reveal>
          <p className="mt-10 text-[10px] font-bold uppercase tracking-[0.25em] text-amber-500">{article.theme_label}</p>
          <h1 className="mt-3 font-display text-3xl font-black tracking-tight sm:text-5xl">{article.title}</h1>
          <p className="mt-3 text-xs uppercase tracking-[0.2em] text-zinc-600">
            {new Date(article.published_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}
          </p>
          {article.image_url && (
            <img src={article.image_url} alt={article.title} data-testid="journal-article-image"
                 className="mt-8 w-full border border-white/10 object-cover" />
          )}
          <div className="mt-8 space-y-5 text-base leading-relaxed text-zinc-300 [&>p]:mb-5"
               data-testid="journal-article-body"
               dangerouslySetInnerHTML={{ __html: article.article_html }} />
          <div className="mt-12 border border-amber-500/30 bg-amber-500/5 p-6">
            <p className="font-display text-lg font-medium">Envie de musique pour vos images ?</p>
            <p className="mt-2 text-sm text-zinc-400">Écoutez le catalogue et licencez en quelques clics.</p>
            <Link to="/catalogue" data-testid="journal-article-cta"
                  className="mt-4 inline-block bg-amber-500 px-6 py-3 text-xs font-bold uppercase tracking-[0.25em] text-black transition-colors hover:bg-amber-400">
              Découvrir le catalogue
            </Link>
          </div>
        </Reveal>
      )}
    </main>
  );
}
